import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';

import Header from '../components/header'
import Footer from '../components/footer'
import Layout from "../views/layout.vue";

Vue.use(VueRouter)


const routes = [
  {path : "/" , redirect : "/index"},
  {
    path: '/index',
    name: 'index',
    components:{
      Header:Header,
      default: () => import('../views/index.vue'),
      Footer:Footer
    },
    meta: {
      needlessAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    components:{
      Header:Header,
      default: () => import('../views/login.vue'),
      Footer:Footer
    },
    meta: {
      needlessAuth: true
    }
  },
  {
    path: '/forget',
    name: 'forget',
    components:{
      Header:Header,
      default: () => import('../views/forget.vue'),
      Footer:Footer
    },
    meta: {
      needlessAuth: true
    }
  },
  {
    path: '/register',
    name: 'register',
    components:{
      Header:Header,
      default: () => import('../views/register.vue'),
      Footer:Footer
    },
    meta: {
      needlessAuth: true
    }
  },
  {
    path: '/search',
    name: 'search',
    components:{
      Header:Header,
      default: () => import('../views/search.vue'),
      Footer:Footer
    },
    meta: {
      needlessAuth: true
    }
  },
  {
    path: '/details',
    name: 'details',
    components:{
      Header:Header,
      default: () => import('../views/details.vue'),
      Footer:Footer
    },
    meta: {
      needlessAuth: true
    }
  },
  {
    path: '/cart',
    name: 'cart',
    components:{
      Header:Header,
      default: () => import('../views/cart.vue'),
      Footer:Footer
    }
  },
  {
    path: '/placeOrder',
    name: 'placeOrder',
    components:{
      Header:Header,
      default: () => import('../views/placeOrder.vue'),
      Footer:Footer
    }
  },
  {
    path: '/payOrder',
    name: 'payOrder',
    components:{
      Header:Header,
      default: () => import('../views/payOrder.vue'),
      Footer:Footer
    }
  },
  {
    path: '/payResult',
    name: 'payResult',
    components:{
      Header:Header,
      default: () => import('../views/payResult.vue'),
      Footer:Footer
    }
  },
  {
    path: '/richtext',
    name: 'richtext',
    redirect: '/richtext/privacy',
    component: Layout,
    children: [
      {
        path: 'privacy',
        name: 'privacy',
        component: () => import('../views/richtext/privacy.vue'),
      },
      {
        path: 'creditRule',
        name: 'creditRule',
        component: () => import('../views/richtext/privacy.vue'),
      },
      {
        path: 'paymentAgreement',
        name: 'paymentAgreement',
        component: () => import('../views/richtext/privacy.vue'),
      },
    ]
  },
  {
    path: '/messageCenter',
    name: 'messageCenter',
    components:{
      Header:Header,
      default: () => import('../views/messageCenter/index.vue'),
      Footer:Footer
    }
  },
  {
    path: '/behalfDetail',
    name: 'behalfDetail',
    components:{
      Header:Header,
      default: () => import('../views/personal/behalfDetail.vue'),
      Footer:Footer
    }
  },
  {
    path: '/personal',
    name: 'personal',
    components:{
      Header:Header,
      default: () => import('../views/personal/index.vue'),
      Footer:Footer,
    },   
    redirect: '/personal/myOrder',
    children: [
      {
        path: 'myOrder',
        name: 'myOrder',
        component: () => import('../views/personal/myOrder.vue'),
      },
      {
        path: 'orderReconciliation',
        name: 'orderReconciliation',
        component: () => import('../views/personal/orderReconciliation.vue'),
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('../views/personal/orderDetail.vue'),
      },
      {
        path: 'orderEvaluate',
        name: 'orderEvaluate',
        component: () => import('../views/personal/orderEvaluate.vue'),
      },
      {
        path: 'balance',
        name: 'balance',
        component: () => import('../views/personal/balance.vue'),
      },
      {
        path: 'cashierDesk',
        name: 'cashierDesk',
        component: () => import('../views/personal/cashierDesk.vue'),
      },
      {
        path: 'integral',
        name: 'integral',
        component: () => import('../views/personal/integral.vue'),
      },
      {
        path: 'clientManagement',
        name: 'clientManagement',
        component: () => import('../views/personal/clientManagement.vue'),
      },
      {
        path: 'consumptionStatistics',
        name: 'consumptionStatistics',
        component: () => import('../views/personal/consumptionStatistics.vue'),
      },
      {
        path: 'reconciliationDocument',
        name: 'reconciliationDocument',
        component: () => import('../views/personal/reconciliationDocument.vue'),
      },
      {
        path: 'credit',
        name: 'credit',
        component: () => import('../views/personal/credit.vue'),
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('../views/personal/coupon.vue'),
      },
      {
        path: 'info',
        name: 'info',
        component: () => import('../views/personal/info.vue'),
      },
      {
        path: 'address',
        name: 'address',
        component: () => import('../views/personal/address.vue'),
      },
      {
        path: 'account',
        name: 'account',
        component: () => import('../views/personal/account.vue'),
      },
      {
        path: 'changePassword',
        name: 'changePassword',
        component: () => import('../views/personal/changePassword.vue'),
      },
      {
        path: 'changePayPassword',
        name: 'changePayPassword',
        component: () => import('../views/personal/changePayPassword.vue'),
      },
      {
        path: 'changePhone',
        name: 'changePhone',
        component: () => import('../views/personal/changePhone.vue'),
      },
      {
        path: 'invoice',
        name: 'invoice',
        component: () => import('../views/personal/invoice.vue'),
      },
      {
        path: 'addInvoice',
        name: 'addInvoice',
        component: () => import('../views/personal/addInvoice.vue'),
      },
      {
        path: 'real',
        name: 'real',
        component: () => import('../views/personal/real.vue'),
      },
      {
        path: 'agentInfo',
        name: 'agentInfo',
        component: () => import('../views/personal/agentInfo.vue'),
      },
      {
        path: 'salesman',
        name: 'salesman',
        component: () => import('../views/personal/salesman.vue'),
      },
      {
        path: 'activityCenter',
        name: 'activityCenter',
        component: () => import('../views/personal/activityCenter.vue'),
      },
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('../views/personal/feedback.vue'),
      },
    ]
  },
]
// 重写push,避免重定向没有捕获catch报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, resolve, reject) {
  if ( resolve || reject ) return originalPush.call(this, location, resolve, reject)
  return originalPush.call(this, location).catch((e)=>{})
}
const router = new VueRouter({
  base: '/web/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 }); // 滚动到顶部
      }, 100); // 可选的延迟时间
    });
}
})

router.beforeEach((to, from, next) => {
  if (store.state.loginInfo.hasLogin || to.matched.some(record => record.meta.needlessAuth)) {
    next();
  } else {
    next('/login');
  }
});

export default router
